import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IMeetingConfigBulkOverrideMutationOptions {
	onSuccess?: (data: Api.IBulkMeetingConfigOverrideResponse) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

export function useMeetingConfigBulkOverrideMutation(options: IMeetingConfigBulkOverrideMutationOptions = {}) {
	const { onSuccess, onError } = options;
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: Api.IBulkMeetingConfigOverrideRequest) => {
			// This API uses BulkOperationResult pattern which returns the response directly
			// at the top level (with success, succeeded, failed arrays), NOT wrapped in a
			// "value" property like standard OperationResult<T>. We use callWebServiceAsync
			// instead of callAsync to get the raw response, then cast to the expected type.
			const result = await userSession.webServiceHelper.callWebServiceAsync<Api.IBulkMeetingConfigOverrideResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'TeamMeetingConfig/applySettings',
				}),
				'POST',
				request
			);

			if (!result.success) {
				throw result;
			}

			return result as unknown as Api.IBulkMeetingConfigOverrideResponse;
		},
		onSuccess,
		onError,
	});
}
